import React from "react";
import CommunityListPage from "../community/components/CommunityListPage";
import { OTHER_REQUESTS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function OtherRequestsPage() {
  useRequireSectionVisible("showOtherRequests");
  return <CommunityListPage section={OTHER_REQUESTS} />;
}
